<mat-toolbar color="accent">{{ title() }}</mat-toolbar>

<mat-dialog-content class="!text-black">
  <form class="flex flex-col gap-4" [formGroup]="formGroup">
    @if (isDisabled$ | async) {
      <pr-information-box>
        <div>Recalls are currently disabled for this patient.</div>
        <button mat-stroked-button color="primary" (click)="resetNextDue()">
          Enable Recalls
        </button>
      </pr-information-box>
    } @else {
      <div class="flex flex-row gap-4 rounded-md bg-slate-100 px-4 py-2">
        <pr-recall-appointment
          class="flex grow"
          label="Last Recall Appointment"
          [appointmentRef]="formGroup.value.lastRecallAppointment"
          [recallDate]="formGroup.value.lastCompletedAt"
        />
        <pr-recall-appointment
          class="flex grow"
          label="Next Recall Appointment"
          emptyMessage="Not Booked"
          [appointmentRef]="formGroup.value.nextRecallAppointment"
        />
      </div>

      <div class="flex flex-row gap-1">
        <mat-form-field
          class="flex grow"
          subscriptSizing="dynamic"
          floatLabel="always"
        >
          <mat-label>Recall Period</mat-label>
          <input matInput type="number" min="1" [formControl]="periodCtrl" />
          <span matTextSuffix>months</span>
          <button
            mat-icon-button
            matSuffix
            matTooltip="Use default period {{
              defaultPeriod() ? 'of ' + defaultPeriod() + ' months' : ''
            }}"
            [disabled]="!formGroup.value.periodIsExplicit"
            (click)="resetRecallPeriod()"
          >
            <mat-icon>restart_alt</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="flex flex-row gap-1">
        <mat-form-field class="flex grow" subscriptSizing="dynamic">
          <mat-label>Next Due</mat-label>
          <input
            matInput
            [formControl]="nextDueCtrl"
            [matDatepicker]="picker"
          />
          <mat-datepicker-toggle
            matIconSuffix
            matTooltip="Select next due date"
            [for]="picker"
          />
          <mat-datepicker #picker />
          <button
            mat-icon-button
            matSuffix
            matTooltip="Clear next due date"
            [disabled]="!formGroup.value.nextDue"
            (click)="clearNextDue()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
        <button
          mat-stroked-button
          color="primary"
          matTooltip="Use recall settings to find the patient's last recall appointment and set when their next recall appointment is due"
          (click)="resetNextDue()"
        >
          Find Next Due Date
        </button>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  @if (!formGroup.value.disabled) {
    <button mat-stroked-button color="warn" (click)="disableRecalls()">
      Disable Recalls
    </button>
  }
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="formGroup.invalid"
    (click)="submit()"
  >
    Save
  </button>
</mat-dialog-actions>
